import { clone } from 'lodash';

const initState = {
  accounts: [],
  isFetching: false,
  openDialog: false,
  page: 0,
  pageSize: 20,
  totalCount: 0,
  checkedAccounts: [],
};

function accounts(state = initState, action) {
  switch (action.type) {
    case 'CLEAR_STATE':
      return initState;
    case 'SET_ACCOUNTS':
      return { ...state, accounts: action.accounts };
    case 'ADD_ACCOUNT':
      return { ...state, accounts: [...state.accounts, action.account] };
    case 'EDIT_ACCOUNT':
      return {
 ...state,
        accounts: state.accounts.map((account) => {
            if (account.uuid === action.account.uuid) {
              return { ...account, ...action.account };
            }

            return account;
          }),
};
    case 'OPEN_ACCOUNT_DIALOG':
      return { ...state, openDialog: true, mode: action.mode };
    case 'CLOSE_ACCOUNT_DIALOG':
      return { ...state, openDialog: false };
    case 'ACCOUNT_REQUEST':
      return { ...state, isFetching: true };
    case 'ACCOUNT_REQUEST_SUCCESS':
      return { ...state, isFetching: false, openDialog: false };
    case 'ACCOUNT_REQUEST_ERROR':
      return { ...state, isFetching: false, error: action.error };
    case 'CHANGE_PAGE_OR_SIZE':
      return { ...state, page: action.pageIndex, pageSize: action.pageSize };
    case 'SET_TOTAL_COUNT':
      return { ...state, totalCount: action.count };
    case 'DESELECT_ALL_ACCOUNTS':
      return { ...state, checkedAccounts: [] };
    case 'TOGGLE_CHECKED_ACCOUNTS': {
      const isChecked = state.checkedAccounts.filter((checked) => (checked.uuid === action.account.uuid)).length > 0;
      const checkedAccounts = isChecked
        ? state.checkedAccounts.filter((account) => (account.uuid !== action.account.uuid))
        : [...state.checkedAccounts, clone(action.account)]; // _clone is needed to avoid changing original store accounts

      return { ...state, checkedAccounts };
    }
    case 'TOGGLE_SELECT_ALL_ACCOUNTS': {
      let checkedAccountsII;
      // Check if all accounts on current page is checked
      const allSelected = state.checkedAccounts
        .filter((checked) => (state.accounts.filter((acc) => (checked.uuid === acc.uuid)).length > 0))
        .length === state.accounts.length;

      if (allSelected) {
        // Filter checked accounts to exclude accounts from current page
        checkedAccountsII = state.checkedAccounts
          .filter((checked) => (state.accounts.filter((acc) => (acc.uuid === checked.uuid)).length === 0));
      } else {
        // Find accounts which is not selected yet
        const notSelected = state
          .accounts
          .filter((acc) => (state.checkedAccounts.filter((checked) => (checked.uuid === acc.uuid)).length === 0));

        // And add them to checked array
        checkedAccountsII = [...state.checkedAccounts, ...notSelected];
      }

      return { ...state, checkedAccounts: checkedAccountsII };
    }
    default:
      return state;
  }
}

export default accounts;
